import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../services/userService";

export const fetchUsers=createAsyncThunk(
    "users/fetch",
    async()=>{

        return await userService.getUsers();

    }
);

export const removeUser=createAsyncThunk(
    "users/delete",
    async(id)=>{

        await userService.deleteUser(id);

        return id;

    }
);
export const addUser = createAsyncThunk(
    "users/add",

    async (userData, thunkAPI) => {

        console.log(
            "Redux User Data:",
            userData
        );

        try {

            return await userService.addUser(
                userData
            );

        } catch (error) {

            console.error(
                "Add User Error:",
                error
            );

            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                "Unable to add user."
            );
        }
    }
);

export const addUserxxx = createAsyncThunk(
    "users/add",
    async (formData, thunkAPI) => {
		console.log(formData);
        try {
            return await userService.addUser(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const userSlice=createSlice({

    name:"users",

    initialState:{
        users:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchUsers.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchUsers.fulfilled,(state,action)=>{
    state.loading=false;
    state.users=action.payload;
})

.addCase(fetchUsers.rejected,(state)=>{
    state.loading=false;
})

.addCase(addUser.fulfilled,(state,action)=>{

    state.users.unshift(action.payload);

})

.addCase(removeUser.fulfilled,(state,action)=>{

    state.users=
    state.users.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default userSlice.reducer;